import { gql } from '@apollo/client';

export const sharingPermissionsMutation = gql`
  mutation updateProgramsSharingPermissions(
    $id: String!
    $sharingPermissionsExtended: SharingPermissionsInput!
  ) {
    updateIndividual(
      input: {
        individualId: $id
        sharingPermissionsExtended: $sharingPermissionsExtended
      }
    ) {
      individualId
    }
  }
`;
